import { render, staticRenderFns } from "./UserDetailsAdmin.vue?vue&type=template&id=80806390&scoped=true"
import script from "./UserDetailsAdmin.vue?vue&type=script&lang=js"
export * from "./UserDetailsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80806390",
  null
  
)

export default component.exports